<template>
  <div class="align-v-center cover-bg">
    <v-container grid-list-md text-xs-center>
      <v-layout align-center justify-center row>
        <v-flex sm12 md12>
          <v-card flat class="pb-4">
            <offset-heading
              titleClass="mb-2 headline font-weight-bold"
              :title="title"
              :subtitle="`Select the ${title} that you would like to access`"
              isSelector="true"
            />
            <div class="px-4 mx-1 mt-7 pt-7" v-if="items.length === 0">
              <p>
                Sorry you dont have any associated {{ title }}. Please contact
                support.
              </p>
            </div>
            <div class="px-4 mx-1 mt-7 pt-7" v-else>
              <v-layout row wrap justify-space-between>
                <v-flex
                  px-4
                  sm12
                  xs12
                  md6
                  lg6
                  v-bind:key="index"
                  v-for="(item, index) in items"
                >
                  <v-card
                    hover
                    class="elevation-12 mb-4 pointer account-list"
                    @click.prevent="nextStep(item)"
                  >
                    <div class="c-layout">
                      <div class="cl-flex6">
                        <div class="min-h-80 v-center bg-grey">
                          <img
                            src="@/assets/images/uno-logo.png"
                            class="account-logo"
                          />
                        </div>
                      </div>
                      <div class="cl-flex6">
                        <div class="min-h-80 section-excerpt v-center">
                          <h2 class="font-weight-bold title">
                            {{ item.name }}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import OffsetHeading from '@/components/OffsetHeading'

export default {
  name: 'Selector',

  components: {
    OffsetHeading
  },

  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },

  methods: {
    nextStep(item) {
      if (this.$route.name === 'Business') this.$emit('setBusiness', item.id)
      else if (this.$route.name === 'Location') this.$emit('setLocation', item)
    }
  }
}
</script>
